'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Card;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./card.scss');

var _Title = require('../typography/Title');

var _Title2 = _interopRequireDefault(_Title);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Card(props) {
  var title = props.title,
      footer = props.footer,
      children = props.children,
      customClass = props.customClass,
      outsideTitle = props.outsideTitle;
  var outterTitle = outsideTitle ? _react2.default.createElement(_Title2.default, {
    text: title
  }) : '';
  var innerTitle = outsideTitle ? '' : _react2.default.createElement(_Title2.default, {
    text: title
  });
  var style = customClass || '';
  return _react2.default.createElement('div', {
    className: 'card-container'
  }, outterTitle, _react2.default.createElement('div', {
    className: 'card ' + style
  }, innerTitle, children, footer));
}

Card.propTypes = {
  title: _propTypes2.default.string,
  footer: _propTypes2.default.node,
  children: _propTypes2.default.node.isRequired,
  customClass: _propTypes2.default.string,
  outsideTitle: _propTypes2.default.bool
};
Card.defaultProps = {
  title: '',
  footer: '',
  customClass: '',
  outsideTitle: false
};